const moment = require("moment");
function formatDateToThai(date: Date) {
  let value = new Date(date);
  const thaiYear = value.getFullYear() + 543;
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");
  return `${thaiYear}/${month}/${day}`;
}

function formatNumberWithCommas(number: number) {
  return number
    .toFixed(0)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function formatMinutesToHHMM(minutes: number) {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  const hoursStr = hours.toString().padStart(2, "0");
  const minutesStr = remainingMinutes.toString().padStart(2, "0");

  return `${hoursStr}:${minutesStr}`;
}

function formatUnixDateToThai(timestamp: number): string {
  const date: moment.Moment = moment.unix(timestamp);
  date.add(543, "years");
  return date.format("DD/MM/YYYY");
}

export {
  formatDateToThai,
  formatNumberWithCommas,
  formatMinutesToHHMM,
  formatUnixDateToThai,
};
